module.exports = __webpack_public_path__ + "static/media/48_A.2a30c721.png";